import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

type Padding = 'none' | 'sm' | 'md' | 'lg';

export function Divider({
    padding = 'none',
    orientation = 'horizontal',
}: {
    padding?: Padding;
    orientation?: 'horizontal' | 'vertical';
}) {
    if (orientation === 'vertical') {
        return <VerticalDivider $padding={padding} />;
    }
    return <HorizontalLine $padding={padding} />;
}

const PADDING_PX: Record<Padding, number> = { none: 0, sm: 8, md: 16, lg: 24 };

const HorizontalLine = styled('hr')<{ $padding: Padding }>(({ $padding }) => ({
    border: 'none',
    borderTop: `1px solid ${Colors.border}`,
    margin: 0,
    marginTop: PADDING_PX[$padding],
    marginBottom: PADDING_PX[$padding],
}));

const VerticalDivider = styled('div')<{ $padding: Padding }>(({ $padding }) => ({
    border: 'none',
    borderLeft: `1px solid ${Colors.border}`,
    margin: 0,
    marginLeft: PADDING_PX[$padding],
    marginRight: PADDING_PX[$padding],
    height: '100%',
}));
